import { Fetcher } from '@pp/core';

import { RecentResultTypePercentage } from './types';


export interface FetchRecentResultsPercentageParams {
  JSESSIONID: string;
  tableId: string;
  noOfGames: number;
  ck:string;
  url: string;
}

export const fetchRecentResultsPercentage = ({ JSESSIONID, tableId, noOfGames,ck, url }: FetchRecentResultsPercentageParams): Promise<RecentResultTypePercentage> => {
  return Fetcher
    .fetch<RecentResultTypePercentage>(url, {
      params: {
        JSESSIONID,
        tableId,
        noOfGames,
        ck
      },
    });
};
